import { cancelTrial } from './cancel-trial';
import { create } from './create';

export const salesforce = {
  create,
  cancelTrial,
};
